module.exports = __webpack_public_path__ + "img/coupon-bg.4c6208fc.png";